import AbortService from "@rmp/core/services/abortService";
import { Api } from "@rmp/api-id";
import BaseApiController from "@rmp/core/api/base/baseApiController";

const authAppBaseUrl = process.env.VUE_APP_OIDC_AUTHORITY!;

export default class BaseAuthController extends BaseApiController<Api<any>> {
	constructor(abortService: AbortService) {
		super(config => new Api<any>({ ...config, withCredentials: true }), authAppBaseUrl, abortService, {
			withAuthentication: false
		});
	}
}
